jQuery( document ).ready( function ( $ ) {
	function YOUTUBE() {
		console.log( '[JTF Gut Block - JS] jtf/jtf-youtube (media block) v2.0' )
		this.init()
	}

	YOUTUBE.prototype.resizeOnWindowChange = function () {
		$( '.jtf__mediablock' ).each( function () {
			const thisAspectH = $( this ).find( 'a' ).attr( 'data-aspecth' )
			const thisAspectW = $( this ).find( 'a' ).attr( 'data-aspectw' )
			const thisWidth = $( this ).width()
			const oneOfThisWidth = thisWidth / thisAspectW
			const newHeight = oneOfThisWidth * thisAspectH

			$( this ).find( '.jtf__mediablock__placeholder' ).css( {
				'height': newHeight + 'px',
			} )

			$( this ).find( 'iframe' ).attr( 'height', oneOfThisWidth * thisAspectH + 'px' )
		} )
	}

	/**
	 * Default actions happening on device actions
	 */
	YOUTUBE.prototype.init = function () {
		const self = this
		// preserve the 16:9 aspect ratio for the block on load
		$( document ).ready( function () {
			self.resizeOnWindowChange()
		} )

		// preserve the 16:9 aspect ratio for the block on window resize
		$( window ).resize( function () {
			self.resizeOnWindowChange()
		} )

		// preserve the 16:9 aspect ratio when block is displayed within a tab / toggle section
		// // If tab / toggle content section exists on the page
		if (
			$( '.wp-block-jtf-jtf-tab-toggle-content' ).length > 0 &&
			$( '.jtf__tabtoggleblock__content' ).length > 0
		) {
			let tabId = 0
			// // On tab / toggle click
			$( '.jtf__tabtoggleblock__items__item' ).on( 'click', function () {
				// // Store the tab / toggle button id
				tabId = $( this ).attr( 'id' )
				// //  Check if the content section exists for the tab / toggle
				if ( $( '#' + tabId + 'Content' ).length > 0 ) {
					// // Check if a JTF Media block exists within the content section
					if ( $( '#' + tabId + 'Content' ).find( '.wp-block-jtf-jtf-youtube' ).length > 0 ) {
						// // Run the function after a slight delay
						setTimeout(
							function () {
								self.resizeOnWindowChange()
							},
							100,
						)
					}
				}
			} )

		}

		$( document ).on( 'click', '.jtf__mediablock__placeholder', function ( e ) {
			e.preventDefault()
			const parent = $( this ).parent()
			const videoID = parent.attr( 'data-url' )
			const videoType = parent.attr( 'data-type' )
			// 16:9 ratio, height gets calculated based off the width of the container
			const thisAspectH = $( this ).attr( 'data-aspecth' )
			const thisAspectW = $( this ).attr( 'data-aspectw' )
			const thisWidth = $( this ).width()
			const oneOfThisWidth = thisWidth / thisAspectW

			$( this ).remove()

			switch ( videoType ) {
				case 'vm':
					parent.append( '<iframe width="100%" height="' + oneOfThisWidth * thisAspectH + 'px" src="https://player.vimeo.com/video/' + videoID + '?badge=0&autopause=0&player_id=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe><script src="https://player.vimeo.com/api/player.js"></script>' )
					break
				case 'yt':
					parent.append( '<iframe width="100%" height="' + oneOfThisWidth * thisAspectH + 'px" src="https://www.youtube.com/embed/' + videoID + '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>' )
					break
				case 'ws':
					parent.append(
						'<script src="https://fast.wistia.com/embed/medias/' + videoID + '.jsonp" async></script>' +
						'<script src="https://fast.wistia.com/assets/external/E-v1.js" async></script>' +
						'<div class="wistia_embed wistia_async_' + videoID + ' autoPlay=true" style="height:' + oneOfThisWidth * thisAspectH + 'px;width:100%">&nbsp;</div>',
					)
					break
				case 'bb':
					parent.append( '<iframe width="100%" height="' + oneOfThisWidth * thisAspectH + 'px" src="https://player.bilibili.com/player.html?bvid=' + videoID + '&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>' )
					break
				case 'gtw':
					parent.append( '<iframe width="100%" height="' + oneOfThisWidth * thisAspectH + 'px" src="https://app.gotowebinar.com/unified/index.html#/embedded/recording/' + videoID + '?source=G2S-EMBEDDED" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>' )
					break
				default:
					break
			}
		} )
	}

	if ( $( '.wp-admin' ).length > 0 ) {
		// delay admin so GUT has chance to load
		setTimeout( function () {
			if ( $( '.wp-block-jtf-jtf-youtube' ).length > 0 ) {
				new YOUTUBE()
			}
		}, 4000 )
	} else {
		// Check block is used on this page before instantiating
		if ( $( '.wp-block-jtf-jtf-youtube' ).length > 0 ) {
			new YOUTUBE()
		}
	}
} )

